import createRoutine from '@/utils/createRoutine'

export const leftHandSideBar = createRoutine('leftHandSideBar')
export const rightHandSideBar = createRoutine('rightHandSideBar')

export const navigationBarsGetters = {
  LEFT_HAND_SIDE_BAR: 'LEFT_HAND_SIDE_BAR',
  RIGHT_HAND_SIDE_BAR: 'RIGHT_HAND_SIDE_BAR'
}
